@if (isMobile) {
  <app-carousel [autoMoveItems]="true">
    <div content class="slideBanner__carousel-item" *ngFor="let banner of banners; index as id" [id]="sliderItemId(id)" (click)="selectBanner(banner)">
      <app-image
        [type]="typeImageFlight" 
        [src]="banner.image_url"
        [borderRadius]="14">
      </app-image>
    </div>
  </app-carousel>
} @else {
  <app-slide
    [mechanicalDisplacement]="!isMobile"
    [activated]="!!banners?.length"
    [quantityOfItems]="banners?.length"
    [slideWidth]="slideWidth">
    <div #slideBanner class="slideBanner__content-item" [style.width]="slideWidth + 'px'" *ngFor="let banner of banners; index as id" [id]="sliderItemId(id)" (click)="selectBanner(banner)">
      <div class="slideBanner__image-item">
        <app-image
          [type]="typeImageFlight" 
          [src]="banner.image_url"
          [borderRadius]="14">
        </app-image>
      </div>
    </div>
  </app-slide>
}